
// 开发环境
// const baseUrl = 'http://dev.acspay.cn:8360/'
// 上线环境
const baseUrl = 'https://www.acspay.cn'

export default baseUrl


// WEBPACK FOOTER //
// ./src/config/baseUrl.js